
import lottie from 'lottie-web';

export default {
  name: 'DashAnimatedIcon',
  props: {
    animationId: {
      type: String,
      default: '',
    },
    animationData: {
      type: [String, Object],
      default: null,
    },
    loop: {
      type: Boolean,
      default: false,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { lottie: null };
  },
  computed: {
    path() {
      if (!this.animationId) return null;
      return `/animations/${this.animationId}.json`;
    },
    config() {
      return {
        renderer: 'svg',
        loop: this.loop,
        autoplay: this.autoplay,
        path: this.path,
        animationData: this.animationData,
      };
    },
  },
  watch: {
    config() {
      this.loadAnimation();
    },
  },
  mounted() {
    this.loadAnimation();
  },
  beforeDestroy() {
    this.destroyAnimation();
  },
  methods: {
    loadAnimation() {
      this.destroyAnimation();
      const animationConfig = Object.assign({
        container: this.$refs.animation,
      }, this.config);
      this.lottie = lottie.loadAnimation(animationConfig);
      this.lottie.addEventListener('complete', () => this.$emit('complete'));
    },
    destroyAnimation() {
      if (this.lottie) {
        this.lottie.destroy();
      }
    },
    play() {
      this.lottie.stop();
      this.lottie.play();
    },
    stop() {
      this.lottie.stop();
    },
  },
};
